import "../../Styles/Landing/ClassesL.css";
import { useNavigate } from "react-router-dom";
import { classesData } from "../../Assets/Data/ClassesData";
import ZGA from "../../Assets/ZGA.png";

const ClassesL = () => {
  const navigate = useNavigate();

  const handleClassClick = (classId) => {
    navigate(`/classes/${classId}`);
  };

  return (
    <div className="classesL">
      <div>
        <hr />
        <h1>Our Classes</h1>
        <p>
          At The Zulaykha Global Academy, we offer a diverse range of learning to the unique needs of women and children
          from all walks of life home and abroad.
        </p>
      </div>
      <div>
        {classesData.map((classItem) => (
          <div key={classItem.id} className="class">
            <div>
              <img src={ZGA} alt="The Zulaykha Global Academy" />
              <span>{classItem.name}</span>
              <button onClick={() => handleClassClick(classItem.id)}>{classItem.lpButton}</button>
            </div>
            <div>
              <img src={classItem.image} alt="Background" />
              <div className="gradient"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassesL;
